var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
var SearchBar = function (_a) {
    var onSearch = _a.onSearch, value = _a.value, width = _a.width, maxWidth = _a.maxWidth;
    var t = useTranslation().t;
    var handleInputChange = function (event) {
        onSearch(event.target.value);
    };
    return (_jsx(TextField, { variant: "outlined", label: t('Поиск'), value: value, fullWidth: true, size: "small", onChange: handleInputChange, InputProps: {
            startAdornment: (_jsx(InputAdornment, __assign({ position: "start" }, { children: _jsx(SearchIcon, {}, void 0) }), void 0))
        }, sx: {
            width: width,
            maxWidth: maxWidth || 400,
            '& .MuiOutlinedInput-root': {
                borderRadius: '30px',
                transition: 'all 0.2s ease-in-out'
            }
        } }, void 0));
};
export default SearchBar;
